// extracted by mini-css-extract-plugin
export default {"1100":"(min-width: 1100px)","root":"_fADjFzo56HjVBc87u90","wrap":"XRxuuzpNg8aSshrfUIna"};